import { PASS_URL } from '@/lib/constants';

/**
 * Origine du Pass (`https://pass-recette2.april-moto.com`), déduite de `VITE_URL`.
 *
 * L'API v2 vit sur la même origine que la v1 : on la dérive plutôt que d'ajouter une variable
 * d'environnement qui pourrait diverger de l'autre.
 */
export const PASS_ORIGIN: string = (() => {
    try {
        return new URL(PASS_URL).origin;
    } catch {
        return '';
    }
})();

/** URL absolue d'un chemin du Pass (`/api/v2/perso/…`). */
export const passUrl = (path: string): string => `${PASS_ORIGIN}${path}`;
